const kzs = window.kzs;
const $ = kzs.$;

export const applyExistingExpScript = () => {
  window.kzLoadTool = function (name, cb, ver) {
    var base = "https://cdn.kaizenplatform.net/ui-library/";
    var d = document,
      t = "script",
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    if (!ver) ver = "latest";
    o.src = base + name + "/" + ver + "/" + name + ".js";
    if (cb) {
      o.addEventListener(
        "load",
        function (e) {
          cb(kzs.tools[name][ver]);
        },
        false
      );
    }
    s.parentNode.insertBefore(o, s);
  };
  window.kzWindow = {};
  var methods = [
    "height",
    "innerHeight",
    "innerWidth",
    "outerHeight",
    "outerWidth",
    "scrollLeft",
    "scrollTop",
    "width",
    "on",
    "off",
    "scroll",
  ];
  var win = kzs.$(window);
  kzs.$(methods).each(function (i, k) {
    kzWindow[k] = function () {
      return win[k].apply(win, arguments);
    };
  });
};
